import { IAccessMediator, IProperty, ReportStatus } from "./types";
import { Types } from "./actions";
import {
    checkTextInput,
    checkPeoplePickerValue,
    checkDatePickerValue,
    checkDropdownListValue,
    checkLinkValue,
    checkNotificationPickerValue,
    checkApproverValue,
    checkSPFManagerEditMode
} from "../../core/libraries/Validation";
import Helper from "../../core/libraries/Helper";
import Constants from "../../core/libraries/Constants";
import _, { isArray } from "lodash";
import { removeAliasDomain } from "../../utils/converter";
import { Organization } from "../../services/type";

const initialState: IAccessMediator = {
    //page: PageName.ACCESS_MEDIATOR,
    mode: Constants.ACCESS_MEDIATOR_MODE.VIEW,
    report: null,
    oldReport: null,
    error: "",
    validation: {},
    securityClasses: [],
    documentTypes: [],
    status: '',
    checkBoxChecked: undefined,
    isFirstLoad: true,
    isLoading: true,
    isSPFOLoading: false,
    isROULoading: false,
    isLLCoordinatorLoading: false
};

type dataType = string | IProperty | any;

export const AccessMediatorReducer = (state: IAccessMediator = initialState, action: { type: string, data: dataType }) => {
    switch (action.type) {
        case Types.INIT: {
            let result: IAccessMediator = initialState;
            return result;
        }
        case Types.CHANGE_MODE: {
            let result: IAccessMediator = Object.assign({}, state);
            result.mode = action.data;
            return result;
        }
        case Types.SET_DATA: {
            let result: IAccessMediator = Object.assign({}, state);
            let rs = action.data.result;
            if (!!rs.data && !!rs.data.id) {
                result.report = { ...rs.data };
                result.oldReport = { ...rs.data };
                result.status = rs.data.status;
            }
            else {
                if (rs.message && rs.message !== "") {
                    result.status = rs.message;
                    result.report = null;
                }
            }
            result.isLoading = false;
            if (result.report) {
                switch (result.report.uploadType) {
                    case Constants.UPLOAD_TYPE.RnD: {
                        result.securityClasses = Constants.DD_SECURITY_CLASSES_ALL;
                        break;
                    }
                    case Constants.UPLOAD_TYPE.LL: {
                        result.securityClasses = Constants.DD_SECURITY_CLASSES_ONLY_1;
                        break;
                    }
                    case Constants.UPLOAD_TYPE.Thesis: {
                        result.securityClasses = Constants.DD_SECURITY_CLASSES_ONLY_2;
                        break;
                    }
                    case Constants.UPLOAD_TYPE.Paper: {
                        result.securityClasses = Constants.DD_SECURITY_CLASSES_ONLY_1;
                        break;
                    }
                }
            }
            Helper.runNewTask(() => {
                action.data.callback(result.report);
            });
            return result;
        }
        case Types.VALIDATE_DATA: {
            let result: IAccessMediator = Object.assign({}, state);
            if (state.status === ReportStatus.NO_PERMISSION) {
                // Only check Comment for page Order
                result.validation = checkTextInput({
                    value: state.report.Comment,
                    fieldName: "Comment",
                    displayName: "comment",
                    checkRequired: true
                });
            }
            else {
                result.validation = checkFormValidation(state);
            }
            if (checkValidData(result.validation) === true) {
                Helper.runNewTask(() => {
                    action.data.callback();
                });
            }
            return result;
        }
        case Types.UPDATE_PROPERTY: {
            let property: IProperty = action.data;
            let result: IAccessMediator = Object.assign({}, state);
            let copyReport = { ...state.report };
            copyReport[property.field] = property.value;
            result.report = copyReport
            return result;
        }
        case Types.UPDATE_CHECKBOX: {
            let property: IProperty = action.data;
            let result: IAccessMediator = Object.assign({}, state);
            result.checkBoxChecked = property.value;
            return result;
        }
        case Types.IS_FIRST_LOAD: {
            let property: IProperty = action.data;
            let result: IAccessMediator = Object.assign({}, state);
            result.isFirstLoad = property.value;
            return result;
        }
        case Types.SET_DOCUMENT_TYPES: {
            let result: IAccessMediator = Object.assign({}, state);
            result.documentTypes = action.data;
            return result;
        }
        case Types.SET_SPFO_LOADING: {
            let result: IAccessMediator = Object.assign({}, state);
            result.isSPFOLoading = action.data;
            return result;
        }

        case Types.SET_ROU_LOADING: {
            let result: IAccessMediator = Object.assign({}, state);
            result.isROULoading = action.data;
            return result;
        }

        case Types.SET_LL_COORDINATOR_LOADING: {
            let result: IAccessMediator = Object.assign({}, state);
            result.isLLCoordinatorLoading = action.data;
            return result;
        }

        case Types.SET_CHANGED_DEPARTMENT: {
            let result: IAccessMediator = Object.assign({}, state);
            // Reset loading states when department change completes
            result.isROULoading = false;
            result.isLLCoordinatorLoading = false;

            const rs = action.data.result;
            const hasValidResult = !!rs && isArray(rs) && rs.length > 0;

            if (hasValidResult) {
                const first: Organization = rs[0];
                result.report = {
                    ...state.report,
                    division: first.division,
                    department: first.orgName,
                    rou: first.managerID,
                    spfManager: null
                };
            } else {
                result.report = {
                    ...state.report,
                    division: null,
                    department: null,
                    rou: null,
                    spfManager: null
                };
            }

            // Execute callback if provided
            if (action.data.callback !== undefined) {
                Helper.runNewTask(() => {
                    action.data.callback(hasValidResult ? rs[0] : false);
                });
            }

            return result;
        }
        case Types.SET_CHANGED_SPFO: {
            let result: IAccessMediator = Object.assign({}, state);
            result.isSPFOLoading = false;

            const rs = action.data.result;
            const hasValidResult = !!rs && isArray(rs) && rs.length > 0 && rs[0].division === "CR";

            if (hasValidResult) {
                const first = rs[0];
                result.report = {
                    ...state.report,
                    division: first.division,
                    department: first.orgName,
                    spfManager: first.managerID
                };
            }
            else {
                result.report = {
                    ...state.report,
                    spfManager: null
                };
            }
            // Execute callback if provided
            if (action.data.callback !== undefined) {
                Helper.runNewTask(() => {
                    action.data.callback(hasValidResult ? rs[0] : false);
                });
            }

            return result;
        }
        case Types.SET_CHANGED_DIVISION_ADMIN: {
            let result: IAccessMediator = Object.assign({}, state);
            // Reset loading state when division admin change completes
            result.isLLCoordinatorLoading = false;
            // Create a new report object to ensure re-render
            result.report = {
                ...state.report,
                llDivisionAdmin: !!action.data.result.userPrincipalName ? removeAliasDomain(action.data.result.userPrincipalName) : null
            };
            if (action.data.callback !== undefined) {
                Helper.runNewTask(() => {
                    action.data.callback();
                });
            }
            return result;
        }
        case Types.CALLBACK_UPDATE_REPORT:
        case Types.CALLBACK_RESTART_UPLOAD_WORKFLOW:
        case Types.CALLBACK_DELETE_REPORT: {
            if (action.data.callback !== undefined) {
                Helper.runNewTask(() => {
                    action.data.callback(action.data.result);
                });
            }
        }
    }
    return state;
};

// Main validation
export const checkValidData = (validation: any) => {
    let result: boolean = true;
    for (let key in validation) {
        if (validation[key] !== "" && !_.isUndefined(validation[key])) {
            result = false;
        }
    }
    return result;
}

export const checkFormValidation = (state: IAccessMediator) => {
    let formValidationResult: any = {};
    switch (state.report.uploadType.toUpperCase()) {
        case "RND": {
            formValidationResult = checkRnDForm(state);
            break;
        }
        case "LL": {
            formValidationResult = checkLLForm(state);
            break;
        }
        case "THESIS": {
            formValidationResult = checkThesisForm(state);
            break;
        }
        case "PAPER": {
            formValidationResult = checkPaperForm(state);
            break;
        }
    }

    const oldAuthorDisplayName = state.oldReport?.authorDisplayName;
    const hadAuthorDisplayName = !!oldAuthorDisplayName && oldAuthorDisplayName.trim() !== "";

    if (state.report.uploadType !== Constants.UPLOAD_TYPE.Paper && hadAuthorDisplayName) {
        formValidationResult = {
            ...formValidationResult, ...checkTextInput({
                value: state.report.authorDisplayName,
                fieldName: "authorDisplayName",
                displayName: "external author",
                checkRequired: true,
                maxLength: 250
            })
        };
    }

    //Approver
    formValidationResult = {
        ...formValidationResult, ...checkApproverValue({
            value: state.report.rou,
            fieldName: "rou",
            displayName: "Approver",
            checkRequired: true,
        })
    };
    return formValidationResult;
}

export const checkRnDForm = (state: IAccessMediator) => {
    let result: any = {};
    // Title
    result = {
        ...result, ...checkTextInput({
            value: state.report.title,
            fieldName: "title",
            displayName: "title",
            checkRequired: true,
            minLength: 4,
            maxLength: 250
        })
    };

    if (state.status === ReportStatus.DECLINED) { // Restart
        // Authors
        result = {
            ...result, ...checkPeoplePickerValue({
                condition: state.report.authors.length > 0,
                fieldName: "authors",
                displayName: "authors"
            })
        };

        //Notification
        const maxUserNotification = 50;
        result = {
            ...result, ...checkNotificationPickerValue({
                condition: (state.report.notificationUsers.length <= maxUserNotification) ? true : false,
                fieldName: "notificationUsers",
                displayName: "NotificationUsers",
                maxUserNotification: maxUserNotification
            })
        };
    }

    // Report Date
    result = {
        ...result, ...checkDatePickerValue({
            value: state.report.documentDate,
            fieldName: "documentDate",
            displayName: "report date",
            checkRequired: true,
            checkFutureDate: true
        })
    };

    // Report Type
    result = {
        ...result, ...checkDropdownListValue({
            condition: !_.isNil(state.report.documentType) && state.report.documentType !== "",
            fieldName: "documentType",
            displayName: "report type"
        })
    };

    // Document Number
    result = {
        ...result, ...checkTextInput({
            value: state.report.documentNumber,
            fieldName: "documentNumber",
            displayName: "report number",
            checkRequired: false,
            maxLength: 250
        })
    };

    // Project Number
    result = {
        ...result, ...checkTextInput({
            value: state.report.projectNumber,
            fieldName: "projectNumber",
            displayName: "project number",
            checkRequired: false,
            maxLength: 250
        })
    };

    // Keywords
    result = {
        ...result, ...checkTextInput({
            value: state.report.keywords,
            fieldName: "keywords",
            displayName: "keywords",
            checkRequired: true,
            minLength: 10
        })
    };

    // Abstract
    result = {
        ...result, ...checkTextInput({
            value: state.report.abstract,
            fieldName: "abstract",
            displayName: "abstract",
            checkRequired: true
        })
    };
    if (state.report.division === "CR") {
        result = {
            ...result, ...checkSPFManagerEditMode({
                value: state.report.spfManager,
                fieldName: "spfManager",
                displayName: "SPF Owner",
            })
        };
    }
    return result;
}

export const checkLLForm = (state: IAccessMediator) => {
    let result: any = {};
    // Title
    result = {
        ...result, ...checkTextInput({
            value: state.report.title,
            fieldName: "title",
            displayName: "title",
            checkRequired: true,
            minLength: 4,
            maxLength: 250
        })
    };

    if (state.status === ReportStatus.DECLINED) { // Restart
        // ReportStatus
        result = {
            ...result, ...checkPeoplePickerValue({
                condition: state.report.authors.length > 0,
                fieldName: "authors",
                displayName: "authors"
            })
        };
    }

    // Report Date
    result = {
        ...result, ...checkDatePickerValue({
            value: state.report.documentDate,
            fieldName: "documentDate",
            displayName: "report date",
            checkRequired: true,
            checkFutureDate: true,
        })
    };

    // Keywords
    result = {
        ...result, ...checkTextInput({
            value: state.report.keywords,
            fieldName: "keywords",
            displayName: "keywords",
            checkRequired: true,
            minLength: 10
        })
    };

    const process = (!_.isNil(state.report.process)) ? (state.report.process as string).trim() : "";
    const product = (!_.isNil(state.report.product)) ? (state.report.product as string).trim() : "";
    if (process === "" && product === "") {
        // Process
        result = {
            ...result, ...checkTextInput({
                value: process,
                fieldName: "process",
                displayName: "process",
                checkRequired: true
            })
        };

        // Product
        result = {
            ...result, ...checkTextInput({
                value: product,
                fieldName: "product",
                displayName: "product",
                checkRequired: true
            })
        };
    }
    else {
        // Process
        result = {
            ...result, ...checkTextInput({
                value: process,
                fieldName: "process",
                displayName: "process",
                checkRequired: false,
                maxLength: 250
            })
        };

        // Product
        result = {
            ...result, ...checkTextInput({
                value: product,
                fieldName: "product",
                displayName: "product",
                checkRequired: false,
                maxLength: 250
            })
        };
    }

    // Plant/BU
    result = {
        ...result, ...checkTextInput({
            value: state.report.plantorBu,
            fieldName: "plantorBu",
            displayName: "Plant/BU",
            checkRequired: true
        })
    };

    // IQIS Number
    result = {
        ...result, ...checkTextInput({
            value: state.report.iqisnumber,
            fieldName: "iqisnumber",
            displayName: "IQIS number",
            checkRequired: false,
            maxLength: 250,
        })
    };
    return result;
}

export const checkThesisForm = (state: IAccessMediator) => {
    let result: any = {};
    // Title
    result = {
        ...result, ...checkTextInput({
            value: state.report.title,
            fieldName: "title",
            displayName: "title",
            checkRequired: true,
            minLength: 4,
            maxLength: 250
        })
    };

    if (state.status === ReportStatus.DECLINED) { // Restart
        // Authors
        if (state.checkBoxChecked === true) {
            result = {
                ...result, ...checkPeoplePickerValue({
                    condition: true,
                    fieldName: "authors",
                    displayName: "authors"
                })
            };
        }
        else {
            result = {
                ...result, ...checkPeoplePickerValue({
                    condition: state.report.authors.length > 0,
                    fieldName: "authors",
                    displayName: "authors"
                })
            };
        }


        //Notification
        const maxUserNotification = 50;
        result = {
            ...result, ...checkNotificationPickerValue({
                condition: (state.report.notificationUsers.length <= maxUserNotification) ? true : false,
                fieldName: "notificationUsers",
                displayName: "NotificationUsers",
                maxUserNotification: maxUserNotification
            })
        };
    }

    if (state.status === ReportStatus.DECLINED) { // Restart
        // Authors Display Name
        if (state.checkBoxChecked === true) {
            result = {
                ...result, ...checkTextInput({
                    value: state.report.authorDisplayName,
                    fieldName: "authorDisplayName",
                    displayName: "Author Display Name",
                    checkRequired: true,
                    minLength: 4,
                    maxLength: 250
                })
            }
        }

        //Notification
        const maxUserNotification = 50;
        result = {
            ...result, ...checkNotificationPickerValue({
                condition: (state.report.notificationUsers.length <= maxUserNotification) ? true : false,
                fieldName: "notificationUsers",
                displayName: "NotificationUsers",
                maxUserNotification: maxUserNotification
            })
        };
    }

    // Report Date
    result = {
        ...result, ...checkDatePickerValue({
            value: state.report.documentDate,
            fieldName: "documentDate",
            displayName: "report date",
            checkRequired: true,
            checkFutureDate: true
        })
    };

    // Report Type
    result = {
        ...result, ...checkDropdownListValue({
            condition: !_.isNil(state.report.documentType) && state.report.documentType !== "",
            fieldName: "documentType",
            displayName: "report type",
        })
    };

    // Keywords
    result = {
        ...result, ...checkTextInput({
            value: state.report.keywords,
            fieldName: "keywords",
            displayName: "keywords",
            checkRequired: true,
            minLength: 10
        })
    };

    // Abstract
    result = {
        ...result, ...checkTextInput({
            value: state.report.abstract,
            fieldName: "abstract",
            displayName: "abstract",
            checkRequired: true
        })
    };
    return result;
}

export const checkPaperForm = (state: IAccessMediator) => {
    let result: any = {};
    // Attached Url
    result = {
        ...result, ...checkLinkValue({
            value: state.report.attachedUrl,
            fieldName: "attachedUrl",
            displayName: "url",
            checkRequired: state.report.HasAttachment === false,
        })
    };

    // Title
    result = {
        ...result, ...checkTextInput({
            value: state.report.title,
            fieldName: "title",
            displayName: "title",
            checkRequired: true,
            minLength: 4,
            maxLength: 250
        })
    };

    if (state.status === ReportStatus.DECLINED) { // Restart
        // Authors
        result = {
            ...result, ...checkPeoplePickerValue({
                condition: state.report.authors.length > 0,
                fieldName: "authors",
                displayName: "authors"
            })
        };

        //Notification
        const maxUserNotification = 50;
        result = {
            ...result, ...checkNotificationPickerValue({
                condition: (state.report.notificationUsers.length <= maxUserNotification) ? true : false,
                fieldName: "notificationUsers",
                displayName: "NotificationUsers",
                maxUserNotification: maxUserNotification
            })
        };
    }

    // Report Date
    result = {
        ...result, ...checkDatePickerValue({
            value: state.report.documentDate,
            fieldName: "documentDate",
            displayName: "report date",
            checkRequired: true,
            checkFutureDate: true
        })
    };

    // Report Type
    result = {
        ...result, ...checkDropdownListValue({
            condition: state.report.documentType,
            fieldName: "documentType",
            displayName: "report type",
        })
    };

    if (!_.isNil(state.report.documentType)) {
        switch (state.report.documentType.toUpperCase()) {
            case "CONFERENCE PAPER": {
                // Name of conference
                result = {
                    ...result, ...checkTextInput({
                        value: state.report.nameOfConference,
                        fieldName: "nameOfConference",
                        displayName: "name of conference",
                        checkRequired: true,
                        minLength: 5,
                        maxLength: 250
                    })
                };
                // Location of conference
                result = {
                    ...result, ...checkTextInput({
                        value: state.report.locationOfConference,
                        fieldName: "locationOfConference",
                        displayName: "location of conference",
                        checkRequired: true,
                        minLength: 4
                    })
                };
                // Date of conference
                result = {
                    ...result, ...checkDatePickerValue({
                        value: state.report.dateOfConference,
                        fieldName: "dateOfConference",
                        displayName: "date of conference",
                        checkRequired: true,
                        checkFutureDate: true
                    })
                };
                break;
            }
            case "JOURNAL PAPER": {
                // Name of journal
                result = {
                    ...result, ...checkTextInput({
                        value: state.report.nameOfJournal,
                        fieldName: "nameOfJournal",
                        displayName: "name of journal",
                        checkRequired: true,
                        minLength: 5,
                        maxLength: 250
                    })
                };
                // Date of publication
                result = {
                    ...result, ...checkDatePickerValue({
                        value: state.report.dateOfPublication,
                        fieldName: "dateOfPublication",
                        displayName: "date of publication",
                        checkRequired: true,
                        checkFutureDate: true
                    })
                };
                break;
            }
        }
    }

    // Keywords
    result = {
        ...result, ...checkTextInput({
            value: state.report.keywords,
            fieldName: "keywords",
            displayName: "keywords",
            checkRequired: true,
            minLength: 10
        })
    };

    // Abstract
    result = {
        ...result, ...checkTextInput({
            value: state.report.abstract,
            fieldName: "abstract",
            displayName: "abstract",
            checkRequired: true
        })
    };
    return result;
}